import n from "tdastscript";

function e(n) {
  return "\r\n".includes(n);
}

function t(n, t, o) {
  return t === o - 1 || "," === n || e(n);
}

function o(n) {
  var e = n[0],
      t = n[n.length - 1];
  if (e && t) return {
    start: e.position.start,
    end: t.position.end
  };
}

export default function (i, r) {
  void 0 === i && (i = ""), void 0 === r && (r = {});

  for (var u = 1, a = 1, s = 0, l = {
    line: u,
    column: a,
    offset: s
  }, c = "", f = 0, p = !1, d = [[]], v = i.length; s < v + 1;) {
    var m = i[s - 1],
        h = i[s],
        x = i[s + 1];

    switch (f) {
      case 0:
        var b = "",
            g = t(x, s, v);
        "" === c && (l = {
          line: u,
          column: a,
          offset: s
        }), '"' === h ? p ? g ? p = !1 : '"' === x && (b = '"', a++, s++) : p = !0 : b = h, !p && g && (f = 1), c += b;
        break;

      case 1:
        "," === h ? f = 0 : e(h) && (f = 2), d[u - 1].push({
          position: {
            start: l,
            end: {
              line: u,
              column: '"' === m ? a - 1 : a,
              offset: '"' === m ? s - 1 : s
            }
          },
          value: c
        }), c = "";
        break;

      case 2:
        e(h) || (f = 0, s--), d[++u - 1] = [], a = 0;
    }

    a++, s++;
  }

  var w = d.reduce(function (e, t, i) {
    var u = r.header && 0 === i,
        a = t.map(function (n, e) {
      var t = n.position,
          o = n.value;
      return u ? {
        type: "column",
        index: e,
        position: t,
        value: o
      } : {
        type: "cell",
        columnIndex: e,
        rowIndex: i,
        position: t,
        value: o
      };
    });

    if (a.length > 0) {
      var s = o(a),
          l = n("row", {
        index: i,
        position: s
      }, a);
      e.push(l);
    }

    return e;
  }, []),
      k = o(w);
  return n("table", {
    position: k
  }, w);
}